import "./App.css";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid2,
  MenuItem,
  Paper,
  Snackbar,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import profileimage from "./profileimage.png";

const products = [
  { id: 1, name: "Anesthesia", zone: "ACU" },
  { id: 2, name: "Cardiology", zone: "ISA" },
  { id: 3, name: "EMS", zone: "EMS" },
  { id: 4, name: "ENT/Otorhinolaryngology", zone: "Urology & ENT" },
  { id: 5, name: "Gastroenterology", zone: "SEGI" },
  { id: 6, name: "Neurology", zone: "ISA" },
  { id: 7, name: "Pulmonology", zone: "Pulmonary" },
  { id: 8, name: "Urology", zone: "Urology & ENT" },
];

function App() {
  const [data, setData] = React.useState();
  const [search, setSearch] = React.useState();
  const [isLoading, setIsLoading] = React.useState();
  const [isSending, setIsSending] = React.useState();
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))

  const lookupRep = async (form) => {
    setIsLoading(true);
    try {
      const product = products.find(
        (x) => x.id.toString() === form.product.toString()
      );

      setSearch({zipcode: form.zipcode, product: product.name});
      
      const params = new URLSearchParams({
        product: product.zone,
        zipcode: form.zipcode,
      });

      const query = await fetch(
        `https://zrimb1zuph.execute-api.us-east-1.amazonaws.com/api/lookup-sales-rep?${params.toString()}`
      );
      const rep = await query.json();
      setData(rep);
    } catch {
    } finally {
      setIsLoading(false);
    }
  };


  console.log(matches)
  return (
    <div className="App">
      <Box sx={{ display: "flex", justifyContent: matches ? "center" : "flex-start", flexDirection: matches ? "row" : "column"  }}>
          <Box padding={4}>
            <Form
              updateData={(data) => {
                lookupRep(data);
              }}
              isLoading={isLoading}
            />
          </Box>
        {data ? (
            <Paper
            sx={{
              marginRight: 4,
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              padding: 4,
            }}
            elevation={4}
          >
            <Box>
              <img
                src={profileimage}
                alt="ProfilePicture"
                style={{ maxWidth: "80px" }}
              />
            </Box>
            {data.isRegionalSalesDirector ? (
              <Typography
                variant="h6"
                style={{ fontWeight: 600, fontSize: "1em" }}
              >
                There currently is not a Sales Representative in your area,
                please contact the Regional Sales Director.
              </Typography>
            ) : null}
            <Box width="fit-content">
              <Typography variant="h6" style={{ fontWeight: 600 }}>
                {data.isRegionalSalesDirector
                  ? "Regional Sales Director:"
                  : "Sales Representative:"}
              </Typography>
              <Typography variant="h6">{data.fullName}</Typography>
            </Box>
            <Box width="100%" marginTop={2} marginBottom={2}>
              <Divider />
            </Box>
            <Box width="100%">
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = new FormData(e.target);

                  const email = form.get("email");
                  const firstName = form.get("firstName");
                  const lastName = form.get("lastName");
                  const message = form.get("message");
                  const title = form.get("title");
                  const phone = form.get("phone");
                  setIsSending(true);
                  try {
                    const query = await fetch(
                      `https://zrimb1zuph.execute-api.us-east-1.amazonaws.com/api/send-message`, {
                        method: "POST",
                        body: JSON.stringify({
                          email, firstName, lastName, message, title, phone, repEmail: data.email, managerEmail: data.managerEmail, ...search
                        })

                      }
                    );

                    // eslint-disable-next-line no-restricted-globals
                    if(parent)
                    {
                      // eslint-disable-next-line no-restricted-globals
                      parent.location.href="https://www.ambuusa.com/salesrepfinder/thank-you"
                    }
                    console.log(query)
                    e.target.reset()
                  } catch {

                  } finally {
                    setIsSending(false);
                  }
                }}
              >
                <TextField
                  required
                  type="email"
                  name="email"
                  label="Your Email Address"
                  fullWidth
                ></TextField>
                <Box
                  display="flex"
                  marginTop={2}
                  marginBottom={2}
                  justifyContent="space-between"
                >
                  <TextField sx={{mr: 1}} required name="firstName" label="First Name"></TextField>
                  <TextField required name="lastName" label="Last Name"></TextField>
                </Box>
                <Box
                  display="flex"
                  marginTop={2}
                  marginBottom={2}
                  justifyContent="space-between"
                >
                  <TextField sx={{mr: 1}} required name="title" label="Title"></TextField>
                  <TextField name="phone" label="Phone"></TextField>
                </Box>

                <TextField
                  multiline
                  minRows={3}
                  name="message"
                  label="Message"
                  fullWidth
                  required
                  
                ></TextField>

                <Box marginTop={2}>
                  <Button
                    variant="contained"
                    type="submit"
                    size="large"
                    fullWidth
                    disabled={isSending}
                  >
                    { isSending ? <CircularProgress /> : "Send Message"}
                  </Button>
                </Box>
              </form>
            </Box>
          </Paper>
        ) : null}
        </Box>
    </div>
  );
}

function Form({ updateData, isLoading}) {
  return (
    <Box padding={4} maxWidth={370} textAlign="left">
      <Typography variant="h4" style={{ fontWeight: 600 }}>
        Find Your Ambu Sales Representative
      </Typography>
      <Box sx={{ height: 16 }}></Box>
      <Divider />
      <Box sx={{ height: 16 }}></Box>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          const data = new FormData(e.target);

          const product = data.get("product");
          const zipcode = data.get("zipcode");
          updateData({
            product,
            zipcode,
          });
        }}
      >
        <TextField
          select
          required
          name="product"
          label="Product/Clinical Area"
          fullWidth
          sx={{ marginBottom: 2 }}
        >
          {products.map((x) => {
            return (
              <MenuItem key={x.id} value={x.id}>
                {x.name}
              </MenuItem>
            );
          })}
        </TextField>

        <TextField
          label="ZIP / Postal Code"
          required
          name="zipcode"
          fullWidth
          placeholder="10023"
        ></TextField>

        <Box sx={{ height: 32 }}></Box>
        <Button disabled={isLoading} variant="contained" type="submit">
          { isLoading ? <CircularProgress /> : "Search"} 
        </Button>
      </form>
    </Box>
  );
}

export default App;
